/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import getInsideSalesUsers from '@dashboardWirelineInsideSalesDepartment/GetInsideSalesUsers/api.service';
// eslint-disable-next-line no-unused-vars
import { TPeriod } from 'shared/CustomRangePicker/CustomRangePicker.models';
import { IInsideSalesUsersItem } from '@dashboardWirelineInsideSalesDepartment/InsideSalesDepartment.models';

export interface IState {
  data: IInsideSalesUsersItem[];
  isLoading: boolean;
  error: object | null;
}

const initialState: IState = {
  data: [],
  isLoading: false,
  error: null,
};

export const getInsideSalesUsersAction = createAsyncThunk(
  'getInsideSalesUsersAction',
  async ({ controller, params }: { controller: AbortController, params: TPeriod },
    { rejectWithValue }) => {
    try {
      const { signal } = controller;
      const { data } = await getInsideSalesUsers(signal, params);
      return data;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

const InsideSalesUsersSlice = createSlice({
  name: 'getInsideSalesUsers',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getInsideSalesUsersAction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getInsideSalesUsersAction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(getInsideSalesUsersAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
        state.data = [];
      });
  },
});

export const getInsideSalesUsersReducer = InsideSalesUsersSlice.reducer;
